import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const offlineCourses = [
  { label: 'Tally Certification with Online Internship', link: 'https://tallyeducation.com/tepl/online-internship/' },
  { label: 'Tally Certification with GST Simulation',   link: 'https://tallyeducation.com/tepl/gst-simulation/' },
  { label: 'Office Automation',                         link: 'https://tallyeducation.com/tepl/offline-courses/office-automation/' },
  { label: 'Complete Guide to Payroll & Income Tax',    link: 'https://tallyeducation.com/tepl/offline-courses/complete-guide-to-payroll-income-tax/' },
  { label: 'Complete Guide to Inventory Management',    link: 'https://tallyeducation.com/tepl/offline-courses/complete-guide-to-inventory-management/' },
];

const quickLinks = [
  { label: 'Home',               to: '/' },
  { label: 'Courses',            to: '/courses' },
  { label: 'Placement',          to: '/placement' },
  { label: 'About Us',           to: '/about' },
  { label: 'Verify Certificate', to: '/verify' },
  { label: 'Learning Center',    to: '/learning' },
  { label: 'Enroll Now',         to: '/register' },
];

const Footer = () => (
  <>
    <Helmet>
      <title>Shrikant Tally Institute | Tally Courses & Placement in Damoh</title>
      <meta name="description" content="Reach out to Shrikant Tally Institute in Damoh for inquiries about our offline and online Tally courses." />
      <meta name="keywords" content="Shrikant Tally Institute, Damoh, Tally courses, offline courses, online courses, accounting, contact us, support, resources, Tally Education" />
    </Helmet>

    <style>{`
      /* ── CTA Banner ── */
      .ft-cta {
        background: linear-gradient(135deg, #ecf3d7 0%, #fffbe5 100%);
        padding: 64px 24px;
      }
      .ft-cta h2 { font-weight: 800; color: #4d3d6c; font-size: clamp(1.5rem, 3vw, 2.2rem); }
      .ft-cta p  { color: #666; font-size: 15px; max-width: 560px; }
      .ft-cta-btn {
        background: #90b732;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 12px 32px;
        font-size: 15px;
        font-weight: 700;
        text-decoration: none;
        display: inline-block;
        transition: transform 0.2s, box-shadow 0.2s;
      }
      .ft-cta-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(144,183,50,0.35);
        color: #fff;
      }
      .ft-cta-img {
        max-height: 260px;
        filter: drop-shadow(0 8px 24px rgba(0,0,0,0.1));
        animation: ftFloat 4s ease-in-out infinite;
      }
      @keyframes ftFloat {
        0%,100% { transform: translateY(0); }
        50%      { transform: translateY(-10px); }
      }

      /* ── Main footer ── */
      .ft-main {
        background: #1e1a2e;
        padding: 60px 24px 32px;
        color: rgba(255,255,255,0.75);
      }
      .ft-brand-name {
        font-size: 20px;
        font-weight: 800;
        color: #fff;
        font-family: 'Bahnschrift Condensed', sans-serif;
        letter-spacing: 0.3px;
      }
      .ft-brand-desc {
        font-size: 13px;
        color: rgba(255,255,255,0.55);
        line-height: 1.7;
        margin-top: 10px;
      }
      .ft-contact-item {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-size: 13px;
        color: rgba(255,255,255,0.65);
        margin-bottom: 10px;
      }
      .ft-contact-item i {
        color: #90b732;
        font-size: 15px;
        margin-top: 2px;
        flex-shrink: 0;
      }
      .ft-col-title {
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        color: #90b732;
        margin-bottom: 18px;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(144,183,50,0.25);
      }
      .ft-link {
        display: block;
        font-size: 13.5px;
        color: rgba(255,255,255,0.62);
        text-decoration: none;
        margin-bottom: 9px;
        transition: color 0.2s, padding-left 0.2s;
        cursor: pointer;
      }
      .ft-link:hover { color: #90b732; padding-left: 4px; }

      /* social */
      .ft-social { display: flex; gap: 10px; margin-top: 20px; }
      .ft-social a {
        width: 36px; height: 36px;
        border-radius: 8px;
        background: rgba(255,255,255,0.08);
        display: flex; align-items: center; justify-content: center;
        color: rgba(255,255,255,0.7);
        font-size: 16px;
        text-decoration: none;
        transition: background 0.2s, color 0.2s;
      }
      .ft-social a:hover { background: #90b732; color: #fff; }

      /* divider */
      .ft-divider { border-color: rgba(255,255,255,0.08); margin: 32px 0 24px; }

      /* bottom bar */
      .ft-bottom {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }
      .ft-bottom p { font-size: 13px; color: rgba(255,255,255,0.45); margin: 0; }
      .ft-bottom-badges { display: flex; gap: 10px; flex-wrap: wrap; }
      .ft-badge {
        background: rgba(144,183,50,0.12);
        border: 1px solid rgba(144,183,50,0.25);
        border-radius: 50px;
        padding: 3px 12px;
        font-size: 11px;
        color: #90b732;
        font-weight: 600;
      }

      @media (max-width: 767px) {
        .ft-cta-img { display: none; }
      }
    `}</style>

    {/* ── CTA Section ── */}
    <div className="ft-cta">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-7 mb-4 mb-md-0">
            <h2>Get Ready For Success</h2>
            <p className="mt-3 mb-4">
              Master Tally at your own pace! Choose from our array of offline and online courses and gain in-depth knowledge in Computerized Accounting, Finance, and Business Administration.
            </p>
            <Link to="/register" className="ft-cta-btn">
              Enroll Now →
            </Link>
          </div>
          <div className="col-md-5 text-center">
            <img
              src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/pana.svg"
              alt="Get Ready"
              className="ft-cta-img img-fluid"
            />
          </div>
        </div>
      </div>
    </div>

    {/* ── Main Footer ── */}
    <div className="ft-main">
      <div className="container">
        <div className="row g-5">

          {/* Brand col */}
          <div className="col-md-4 col-lg-3">
            <img
              src={`${process.env.PUBLIC_URL}/tally.png`}
              alt="logo"
              style={{ height: 40, filter: 'brightness(0) invert(1)', opacity: 0.9, marginBottom: 14 }}
            />
            <div className="ft-brand-name">Shrikant Tally Institute</div>
            <p className="ft-brand-desc">
              Damoh's most trusted name in accounting education since 2007. Authorized partner of Tally Education Pvt. Ltd.
            </p>
            <div className="mt-4">
              <div className="ft-contact-item">
                <i className="bi bi-geo-alt-fill"></i>
                <span>Purana Thana, Nearby SBI ATM,<br />Damoh 470661, Madhya Pradesh</span>
              </div>
              <div className="ft-contact-item">
                <i className="bi bi-telephone-fill"></i>
                <span>9131385180</span>
              </div>
              <div className="ft-contact-item">
                <i className="bi bi-envelope-fill"></i>
                <span>shrikanttallyinstitute@gmail.com</span>
              </div>
            </div>
            <div className="ft-social">
              <a href="#!" title="Facebook"><i className="bi bi-facebook"></i></a>
              <a href="#!" title="Instagram"><i className="bi bi-instagram"></i></a>
              <a href="#!" title="YouTube"><i className="bi bi-youtube"></i></a>
              <a href="#!" title="WhatsApp"><i className="bi bi-whatsapp"></i></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-6 col-md-2">
            <div className="ft-col-title">Quick Links</div>
            {quickLinks.map((l, i) => (
              <Link key={i} to={l.to} className="ft-link" onClick={() => window.scrollTo(0,0)}>
                {l.label}
              </Link>
            ))}
          </div>

          {/* Offline Courses */}
          <div className="col-6 col-md-3">
            <div className="ft-col-title">Offline Courses</div>
            {offlineCourses.map((c, i) => (
              <a key={i} href={c.link} target="_blank" rel="noopener noreferrer" className="ft-link">
                {c.label}
              </a>
            ))}
            <a href="https://tallyeducation.com/tepl/offline-courses/" target="_blank" rel="noopener noreferrer" className="ft-link" style={{ color: '#90b732' }}>
              Explore More →
            </a>
          </div>

          {/* Online Courses */}
          <div className="col-md-4 col-lg-4">
            <div className="ft-col-title">Online Courses</div>
            {[
              'Simplifying Inventory Management with TallyPrime',
              'GST Filing with TallyPrime',
              'Accounts Receivables & Payables with TallyPrime',
              'TDL Essential',
              'Mastering Payroll Management with Tally',
            ].map((c, i) => (
              <span key={i} className="ft-link">{c}</span>
            ))}
            <span className="ft-link" style={{ color: '#90b732' }}>Explore More →</span>
          </div>

        </div>

        <hr className="ft-divider" />

        {/* Bottom bar */}
        <div className="ft-bottom">
          <p>© 2025 <strong style={{ color: 'rgba(255,255,255,0.7)' }}>Shrikant Tally Institute</strong>. All rights reserved.</p>
          <div className="ft-bottom-badges">
            <span className="ft-badge">🏅 ISO 9001:2015</span>
            <span className="ft-badge">✅ Tally Authorized Partner</span>
            <span className="ft-badge">🏆 Emerging Star Award</span>
          </div>
        </div>

      </div>
    </div>
  </>
);

export default Footer;
